import React, { ChangeEvent } from 'react'

import I18n from 'i18n'
import { FormControl, Grid, MenuItem, Select } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import GlobeImage from 'images/globe.svg'
import { languages } from 'utils/languages'
import { map } from 'lodash'

const useStyles = makeStyles((theme) => ({
  select: {
    textTransform: 'uppercase',
    marginLeft: theme.spacing(1)
  },
  selectItem: {
    textTransform: 'uppercase'
  }
}))

const replaceOrInsertLocaleInPath = (newLocale: string) => {
  const path = window.location.pathname
  for (const language of languages) {
    const prefix = `/${language}/`
    if (path.startsWith(prefix)) {
      return path.replace(prefix, `/${newLocale}/`)
    }
  }
  return `/${newLocale}${path}`
}

const currentUrlWithLocale = (newLocale: string) => {
  let url = replaceOrInsertLocaleInPath(newLocale)
  if (window.location.search.length > 0) {
    url += `?${window.location.search}`
  }
  return url
}

const LanguageSelect: React.FC = () => {
  const classes = useStyles()

  const handleChange = (event: ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
    const newLocale = event.target.value as string
    window.location.assign(currentUrlWithLocale(newLocale))
  }
  return (
    <Grid container alignItems='center'>
      <Grid item>
        <img src={GlobeImage} />
      </Grid>
      <Grid item>
        <FormControl>
          <Select name='localePicker' value={I18n.locale} onChange={handleChange} className={classes.select} disableUnderline>
            {map(languages, (language) => (
              <MenuItem value={language} className={classes.selectItem} key={language}>
                {language}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  )
}

export default LanguageSelect
